import {ActionState, CurrentState, NestedReadonly, PlayerColor, TurnState} from '@colonist/game-states'
import {MechanicTurnColonistRushState} from '@colonist/game-base-types'

export class CurrentStateValidator {
    private readonly _currentState: NestedReadonly<CurrentState>
    private readonly _experimentalCurrentState: {currentTurnPlayers: PlayerColor[]} | undefined
    private readonly _mechanicTurnColonistRushState: NestedReadonly<MechanicTurnColonistRushState> | undefined
    private readonly _playerStates: {[key in PlayerColor]?: { actionState: ActionState }} | undefined
    private readonly _playerColors: PlayerColor[]

    constructor(currentState: NestedReadonly<CurrentState>, experimentalCurrentState: {currentTurnPlayers: PlayerColor[]} | undefined,
                mechanicTurnColonistRushState: NestedReadonly<MechanicTurnColonistRushState> | undefined, playerStates: {[key in PlayerColor]?: { actionState: ActionState }} | undefined, playerColors: PlayerColor[]) {
        this._currentState = currentState
        this._experimentalCurrentState = experimentalCurrentState
        this._mechanicTurnColonistRushState = mechanicTurnColonistRushState
        this._playerStates = playerStates
        this._playerColors = playerColors
    }

    get currentState(): NestedReadonly<CurrentState> {
        return this._currentState
    }

    get currentTurnPlayers(): PlayerColor[] {
        return this._experimentalCurrentState?.currentTurnPlayers ?? [this._currentState.currentTurnPlayerColor]
    }

    get currentActivePlayers(): PlayerColor[] {
        if(this._mechanicTurnColonistRushState) {
            const isInitialPlacement = this.currentState.turnState == TurnState.InitialPlacement
            if(isInitialPlacement) return [this._currentState.currentTurnPlayerColor]

            const playersDiscardingCards = this.currentTurnPlayers.filter((playerColor) => this.getPlayerActionState(playerColor) == ActionState.SelectCardsToDiscard)
            if(playersDiscardingCards.length > 0) return playersDiscardingCards

            const playersToggledEndTurn = this.playersToggledEndTurn
            const playersActive = this.currentTurnPlayers.filter((playerColor) => !playersToggledEndTurn.includes(playerColor))
            return playersActive
        } else {
            return this.currentTurnPlayers
        }
    }

    get playersToggledEndTurn(): PlayerColor[] {
        const playersToggledEndTurn = this._mechanicTurnColonistRushState?.playersToggledEndTurn
        if(playersToggledEndTurn == undefined) return []

        return Object.keys(playersToggledEndTurn).map((key) => parseInt(key, 10) as PlayerColor)
    }

    getPlayerActionState(playerColor: PlayerColor): ActionState {
        return this._playerStates?.[playerColor]?.actionState ?? this._currentState.actionState
    }

    hasPlayerToggledEndTurn(playerColor: PlayerColor): boolean {
        return this.playersToggledEndTurn.includes(playerColor)
    }

    isSomePlayerInActionState(actionState: ActionState): boolean {
        return this._playerColors.some((playerColor) => this.getPlayerActionState(playerColor) === actionState)
    }

    getPlayersInActionState(actionState: ActionState): PlayerColor[] {
        return this._playerColors.filter((playerColor) => this.getPlayerActionState(playerColor) === actionState)
    }
}
